import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import message from 'antd/lib/message';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { FirebaseContext } from '../../context/FirebaseContext';
import TimeSheduleClassCard from '../../components/TimeSheduleClassCard';
import Button from '../../NecttosComp/Button/Button';
import { OLoading } from '../../static/svg/icons';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Instruction from '../../Documentation/Instruction';


const getPeriodsList = async ({ queryKey }) => {
  const [_, { collegeId }] = queryKey;
  const instance = await getAxiosTokenInstance();
  let resp;
  if (collegeId) {
    try {
      resp = await instance.get('college/timetable/periods', { params: { collegeId } });
      if (resp.data.statusCode === 400) throw new Error(resp.data.message || 'API Error');
    } catch (error) {
      throw new Error(error?.response?.data?.message || error.message || 'API Error');
    }
  }
  return resp?.data;
};

const updatePeriodsList = async ({ data }) => {
  data?.classes?.forEach(e => {
    delete e.collegeId;
  });
  const instance = await getAxiosTokenInstance();
  const resp = await instance.post('/college/timetable/periods', data);
  if (resp.data.statusCode === 400) throw new Error(resp.data.message || 'API Error');
  return resp.data;
};

function TimeShedulePage({ onClose }) {
  const [classesState, setClassesState] = useState({});
  const [timmerHide, setTimmerHide] = useState(false);
  const { collegeId } = useContext(FirebaseContext);

  const periodsQuery = useQuery(['periods', { collegeId }], getPeriodsList);

  const { mutate, isLoading } = useMutation(updatePeriodsList, {
    onSuccess: (data) => {
      periodsQuery.refetch();
      message.success(data.message);
    },
    onError: (error) => {
      message.error(error.message);
    },
  });

 useEffect(() => {
  if (periodsQuery.data?.list) {
    const obj = {};
    ['1', '2', '3'].forEach(year => {
      const classForYear = periodsQuery.data.list.find(c => c.className.startsWith(year));
      if (classForYear) obj[year] = [classForYear]; // only 1 class per year
    });
    setClassesState(obj);
  }
}, [periodsQuery.data]);



  const setPeriodValue = (pos, index, periodIndex, field, value) => {
    setClassesState(prev => {
      const newClasses = { ...prev };
      const updatedClass = { ...newClasses[pos][index] };
      const updatedPeriods = [...(updatedClass.periods || [])];

      if (!updatedPeriods[periodIndex]) updatedPeriods[periodIndex] = { startTime: '', endTime: '' };
      updatedPeriods[periodIndex][field] = value;

      updatedClass.periods = updatedPeriods;
      newClasses[pos][index] = updatedClass;
      return newClasses;
    });
  };

  const setCountValue = (pos, index, count) => {
    setClassesState(prev => {
      const newClasses = { ...prev };
      const updatedClass = { ...newClasses[pos][index] };
      const currentPeriods = updatedClass.periods || [];
      const newCount = parseInt(count) || 0;

      if (newCount < currentPeriods.length) {
        updatedClass.periods = currentPeriods.slice(0, newCount);
      } else if (newCount > currentPeriods.length) {
        updatedClass.periods = [
          ...currentPeriods,
          ...Array(newCount - currentPeriods.length).fill({ startTime: '', endTime: '' }),
        ];
      }
      newClasses[pos][index] = updatedClass;
      return newClasses;
    });
  };

  const handleSubmit = () => {
    let class1, class2, class3;
    Object.keys(classesState).forEach(key => {
      if (key === '1') class1 = classesState[key][0];
      if (key === '2') class2 = classesState[key][0];
      if (key === '3') class3 = classesState[key][0];
    });

    let classes = [];
    Object.keys(classesState).forEach((t, k) => {
      let referencePeriods = k === 0 ? class1?.periods : k === 1 ? class2?.periods : class3?.periods;
      classesState[t]?.forEach(cls => {
        cls.periods = referencePeriods;
        classes.push(cls);
      });
    });

    const data = { collegeId, classes };
    mutate({ data });
  };

  return (
    <>
      {isLoading && (
        <div className='fixed inset-0 bg-slate-100 dark:bg-zinc-950 bg-opacity-20 flex items-center justify-center z-[9999]'>
          <OLoading />
        </div>
      )}
      <Main title='Period Management' height='97%' width='97%'>
        <Header>
          <div className='flex justify-end w-full'>
            <Instruction keyId={'timetable'}></Instruction>
            <Button type='close' onClick={onClose}>Close</Button>
          </div>
        </Header>
        <Body>
        <div className="text-center text-[36px] dark:text-slate-100 font-bold">
        Period Management
        </div>

          <div className='flex justify-center'>
            {periodsQuery.isLoading ? (
              <OLoading />
            ) : (
              <Fragment>
                {Object.keys(classesState).map(pos => (
                  <div key={pos}>
                    {classesState[pos].map((cls, index) => (
                      <TimeSheduleClassCard
                        key={cls.classId}
                        data={cls}
                        index={index}
                        pos={pos}
                        setTimmerHide={setTimmerHide}
                        setCountValue={(count) => setCountValue(pos, index, count)}
                        setPeriodValue={(periodIndex, field, value) => setPeriodValue(pos, index, periodIndex, field, value)}
                      />
                    ))}
                  </div>
                ))}
              </Fragment>
            )}
          </div>
          <div className='flex justify-end'>
            <Button type='update' onClick={() => (!timmerHide ? handleSubmit() : null)}>Update</Button>
          </div>
        </Body>
      </Main>
    </>
  );
}

export default TimeShedulePage;
